import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Tooltip
} from '@mui/material';
import { styled } from '@mui/material/styles';
import lock from 'src/pages/common/lock.png';
import { checkPermission } from 'src/utils/permission';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchProjectTypeMaster,
  selectProjectType,
  setDataSuccess
} from 'src/features/staticDataSlice';
import ProjectTypeCreateModal from 'src/pages/PolicyProduct/RiskFactor/ProjectType/ProjectTypeCreateModal';


const StyledInputLabel = styled(InputLabel)(({ theme, error }) => ({
  color: error ? theme.palette.error.main : 'inherit',
  background: '#fff',
  padding: '0 4px'
}));

function ProjectTypeList({
  tableListDatas,
  index,
  productId,
  saveRow,
  label,
  handleChange
}) {
  const dispatch = useDispatch();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [newValue, setNewValue] = useState('');
  const [projectTypeCreatePermission, setProjectTypeCreatePermission] = useState(false);

  const projectTypeData = useSelector(selectProjectType);

  useEffect(() => {
    checkPermission('riskFactors', 'Create').then((permission) => {
      setProjectTypeCreatePermission(permission);
    });
  }, []);

  useEffect(() => {
    if (newValue) {
      handleChange('projectType', index, newValue);
    }
  }, [newValue]);

  const handleClose = () => {
    fetchProjectTypeMaster(productId).then((data) =>
      dispatch(setDataSuccess({ dataType: 'projectType', data }))
    );
    setOpenCreateModal(false);
  };

  const error = false; // Hook up validation if needed

  return (
    <>
      <FormControl fullWidth size="small">
        <StyledInputLabel id="select-label-projectType" error={error}>
          {label}
        </StyledInputLabel>
        <Select
          labelId="select-label-projectType"
          id="select-projectType"
          value={tableListDatas[index]?.projectType || ''}
          onChange={(event) => {
            handleChange('projectType', index, event.target.value);
            setNewValue('');
            setTimeout(() => {
              if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
              }
            }, 0);
          }}
          style={{ width: '100%', minWidth: 180 }}
          error={error}
        >
          {projectTypeData?.map((projectType) => (
            <MenuItem key={projectType?.name} value={projectType?.name}>
              {projectType?.name}
            </MenuItem>
          ))}
          <Tooltip
            title={
              projectTypeCreatePermission ? (
                ''
              ) : (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar
                    alt=""
                    src={lock}
                    sx={{ width: 24, height: 24, marginRight: 1 }}
                  />
                  You don't have permission to add Project Type
                </div>
              )
            }
          >
            <Button
              variant="text"
              onClick={() => {
                if (projectTypeCreatePermission) {
                  setOpenCreateModal(true);
                }
              }}
              sx={{ color: projectTypeCreatePermission ? '#5569ff' : 'grey' }}
            >
              Add More
            </Button>
          </Tooltip>
        </Select>
        {error && (
          <FormHelperText error={true}>
            Validation error
          </FormHelperText>
        )}
      </FormControl>

      {openCreateModal && (
        <ProjectTypeCreateModal
          handleClose={handleClose}
          productId={productId}
          setNewValue={setNewValue}
        />
      )}
    </>
  );
}

export default ProjectTypeList;
